export default __webpack_public_path__ + "static/media/hotelsdotcom-498428-2496ff19_w-602632.85fc47f2.jpg";